import * as React from "react";
import { ProductsValuationDetailSummary } from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductsValuationDetailSummary";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { BaseComponent } from "../../../../../../../../react-core/Html/BaseComponent";
import { ProductValuationDetailSummary } from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductValuationDetailSummary";
import { AccountCard } from "./AccountCard";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { LoadingSkeleton } from "../../../../../../../Shared/LoadingSkeleton/LoadingSkeleton";
import { LoadingSkeletonType } from "../../../../../../../Shared/LoadingSkeleton/Contents";
import { PresentationContext } from "../../Common/PresentationViewWrapper";
import { groupProductDetail } from "../../Common/PortfolioDashboardHelper";
import { PortfolioDashboardMultiSelectionStore, PortfolioDashboardStore } from "../../../Store/Variable";
import { StringHelper } from "../../../../../../../../react-core/Helpers/StringHelper";

interface IAccountCardsProps extends React.Props<AccountCards> {
    data?: ProductsValuationDetailSummary;
    isLoading?: boolean;
    slideNumber: number;
    hasReadWriteAccessToAdviser: boolean;
}

interface IAccountCardsState {
    productType: SubAccountType;
}

export class AccountCards extends BaseComponent<IAccountCardsProps, IAccountCardsState> {
    constructor(props: IAccountCardsProps) {
        super(props);
        this.state = {
            productType: SubAccountType.NotSpecified,
        };
    }

    private renderRealElement(): JSX.Element {
        const { data } = this.props;
        const { isPresentationView } = this.context;

        return (
            <>
                {isPresentationView && <div className={"container"}>{data ? this.renderProductDetail() : null}</div>}
                {!isPresentationView && <>{data ? this.renderProductDetail() : null}</>}
            </>
        );
    }

    public render(): JSX.Element {
        const { isLoading } = this.props;
        return (
            <>
                {isLoading ? (
                    <div className="panel-subtle">
                        <LoadingSkeleton type={LoadingSkeletonType.Table} />
                    </div>
                ) : (
                    this.renderRealElement()
                )}
            </>
        );
    }

    private renderProductDetail(): JSX.Element[] {
        const { data, slideNumber } = this.props;
        const { isPresentationView } = this.context;
        const products: Array<ProductValuationDetailSummary> = data ? data.Products : [];
        if (!products) {return null;}
        const stringHelper = new StringHelper();
        const productElement: JSX.Element[] = [];
        if (isPresentationView) {
            const tempList = products.filter((x) => SubAccountTypeHelper.isWrapCash(x.ProductType));

            if (tempList.length > 0) {
                const wrapCash = tempList[0];
                const index = products.indexOf(wrapCash, 0);
                products.splice(index, 1);
                products.push(wrapCash);
            }

            const index = slideNumber - 1;
            const productDom: JSX.Element = (
                <AccountCard
                    key={index}
                    product={products[index]}
                    index={index}
                    hasReadWriteAccessToAdviser={this.props.hasReadWriteAccessToAdviser}
                    stringHelper={stringHelper}
                />
            );
            productElement.push(productDom);
        } else {
            const groupsProducts = groupProductDetail(
                PortfolioDashboardMultiSelectionStore.getData(),
                PortfolioDashboardStore.getData(),
                products,
                "ClAccountId"
            );
            let index = 0;
            Object.keys(groupsProducts).forEach((key) => {
                if (groupsProducts[key]?.length > 0) {
                    productElement.push(<h3>{key} account</h3>);
                }
                productElement.push(
                    <div className="row ad">
                        <>
                            {groupsProducts[key].map((product) => {
                                const productDom: JSX.Element = (
                                    <AccountCard
                                        key={index}
                                        product={product}
                                        index={index}
                                        stringHelper={stringHelper}
                                        hasReadWriteAccessToAdviser={this.props.hasReadWriteAccessToAdviser}
                                    />
                                );
                                index = index + 1;
                                return productDom;
                            })}
                        </>
                    </div>
                );
            });
            productElement.push(<div key="productDetailPopup"></div>);
        }

        return productElement;
    }
}
AccountCards.contextType = PresentationContext;
